<div class="product-container saude-monitore" *ngIf="
    classificationIdentifier === 'monitore-clientes' ||
    classificationIdentifier === 'saude-do-seu-negocio' ||
    classificationIdentifier === 'descomplica'
  ">
  <p *ngIf="productData.preferred" class="recomended">Recomendado</p>
  <div 
  class="product-unit {{(stackingOnePackage && (this.classificationIdentifier === 'saude-do-seu-negocio' || this.classificationIdentifier === 'monitore-clientes'))? 'stacking-one-package-size':''}} 
  {{(productData.preferred && this.classificationIdentifier === 'saude-do-seu-negocio')? 'sdsn-recomended': 'sdsn-not-recomended'}}" 
  
  [class.recomended]="productData.preferred"
    [ngClass]="this.classificationIdentifier !== 'monitore-clientes' ? 'product-info-health' : 'product-info-monitore'">

    <div class="align-info {{(stackingOnePackage && (this.classificationIdentifier === 'monitore-clientes'))? 'stacking-one-package-monitore':''}}">
      <div class="spacing-button {{(stackingOnePackage && (this.classificationIdentifier === 'saude-do-seu-negocio' || this.classificationIdentifier === 'monitore-clientes'))? 'stacking-one-package':''}}
      {{stackingOnePackage && (this.classificationIdentifier === 'monitore-clientes')? 'monitora-spacing-button':''}}">
        <div class="section">
          <h2>{{ removeBreakLine(this.productData.cardTitle) }}</h2>
    
          <!-- Exibição da periodicidade -->
          <p *ngIf="this.periodicity === 'yearly' ">Assinatura anual</p>
          <p *ngIf="this.periodicity === 'monthly' ">Assinatura mensal</p>
          <p *ngIf="this.periodicity === 'trimestral' ">Assinatura trimestral</p>
          <p *ngIf="this.periodicity === 'semestral' ">Assinatura semestral</p>
  
          <div class="{{stackingOnePackage? 'box-monitor':''}}" *ngIf="this.classificationIdentifier === 'monitore-clientes'">
            <p class="monitor">
              <strong>{{ this.productData.featureList[0].name }}</strong>
            </p>
          </div>
        </div>
    
        <!-- Monitore clientes -->
    
        <div *ngIf="this.classificationIdentifier === 'monitore-clientes'" class="product-type-container">
        
          <div class="section">
            <p>Em até {{ numPaymentInstallment }}x de</p>
            <h1>R$ {{ paymentInstallmentValue }}</h1>
            <p>no cartão de crédito</p>
          </div>
    
          <p>ou <b>R$ {{ totalValueBankBillet }}</b> à vista</p>
        </div>
    
        <!-- Fim do Monitore clientes -->
        <!-- Demais produtos -->
    
        <div *ngIf="this.classificationIdentifier !== 'monitore-clientes'" class="product-type-container">
          <div class="section">
            <div class="line-group" *ngIf="this.classificationIdentifier === 'saude-do-seu-negocio' && appliedDiscount">
              <p>De <span class="crossed-discount">R$ {{ baseValue }}</span></p>
              <p>&nbsp; por: </p>
            </div>
            <div class="line-group-align" *ngIf="this.classificationIdentifier === 'saude-do-seu-negocio' && !appliedDiscount && !stackingOnePackage"></div>
            <div class="line-group"
              *ngIf="this.classificationIdentifier !== 'descomplica' ||!descomplicaVitrineDiscountPercentage ">
              <h1>R$ {{ paymentInstallmentValue }}</h1>
              <p>&nbsp;/mês</p>
            </div>
            <div *ngIf="this.classificationIdentifier === 'saude-do-seu-negocio'" class="align-price-per-year">
              <p><strong>R$ {{calculateValuePerYearAfterPercentageDiscount(paymentInstallmentValue)}}</strong> por ano</p>
            </div>
          </div>
    
          <div class="line-group"
            *ngIf="this.classificationIdentifier === 'descomplica' && descomplicaVitrineDiscountPercentage>0">
            <p>
              <b>R$ {{ calculateValueAfterPercentageDiscount(baseValue, descomplicaVitrineDiscountPercentage)}}</b>
            </p>
    
            <p *ngIf="this.periodicity === 'monthly'">&nbsp;por mês</p>
            <p *ngIf="this.periodicity === 'yearly'">&nbsp;por ano</p>
            <p *ngIf="this.periodicity === 'trimestral'">&nbsp;por trimestre</p>
            <p *ngIf="this.periodicity === 'semestral'">&nbsp;por semestre</p>
          </div>
          <p *ngIf="this.classificationIdentifier === 'descomplica' && descomplicaVitrineDiscountPercentage>0"
            class="coupon-apply-descomplica"> com a aplicação de cupom: <b class="coupon-descomplica"> {{couponCode}}</b>
          </p>
        </div>
      </div>
  
      <button (click)="this.navigate($event)">
        ASSINAR AGORA
      </button>
    </div>

    <!-- Fim dos Demais produtos -->

  </div>
</div>

<!-- Produto de recarga -->

<div *ngIf="classificationIdentifier === 'plano-mensal-recarga-pontual'" class="product-container-consulta {{
    productData.preferred ? 'recomended-consulta-container' : ''
  }}">
  <p *ngIf="productData.preferred && classificationIdentifier === 'plano-mensal-recarga-pontual'"
    class="{{ productData.preferred ? 'recomended-consulta' : '' }}">
    Recomendado
  </p>
  <div class="section-container">
    <p *ngIf="toggleDiscountBadgeMobile()" class="discount-badge-text-mobile">
      Pague R$ {{productData.totalValue}} e <strong>Receba R$ {{productData.discountsSum}}</strong>
    </p>
    <div class="section-consulta" [ngClass]="{ 'font-selected': productData.preferred }">
      <div class="consulta-container">
        <div class="row-container">
          <p class="currency">R$</p>
          <h2 class="value-consulta"><span>{{truncCurrency(productData.baseValue)}}</span><span class="decimal-currency">{{decimalCurrency(productData.baseValue)}}</span></h2>
        </div>
      </div>
      <div class="button-buy-container">
        <button (click)="navigate($event)">
          COMPRAR
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Fim dos produtos de recarga -->

<!-- Produto de consulta -->

<div *ngIf="togglePreferredBadge() && type !== 'recharge' " class="product-container-consulta 
            {{ productData.preferred && productData !== currentProductData ? 'recomended-consulta-container' : 
               productData === currentProductData ? 'actual-plan-container' : '' }} 
            {{ showDropdown ? 'no-bottom-borders' : '' }}">
  <p *ngIf="(productData.preferred || productData === currentProductData) && (classificationIdentifier === 'consulta-e-recuperacao-de-dividas' || classificationIdentifier === 'plano-mensal')"
    class="{{ productData.preferred && productData !== currentProductData ? 'recomended-consulta' : productData === currentProductData ? 'recomended-consulta-actual' : '' }}">

    {{(productData === currentProductData) ? 'Plano atual' : 'Recomendado' }}
  </p>
  <div class="section-container {{toggleDiscountBadgeMobile()? 'discount-badge-mobile': ''}}">
    <p *ngIf="toggleDiscountBadgeMobile()" class="discount-badge-text-mobile">
     <strong>Desconto de {{productData.percentDiscount}}%</strong>
    </p>
    <div class="section-consulta"
      [ngClass]="{'font-selected': productData.preferred || productData === currentProductData}">
      <div class="consulta-container">
        <h1 class="product-name" *ngIf="selectedToggle === 1 || classificationIdentifier === 'plano-mensal'">{{ removeBreakLine(extractLastWord(productData.product.name)) }}</h1>
        <div> <p *ngIf="productData.discountedValue !== 0 ">
          <span class="censored">De {{productData.baseValue}}</span>
           por </p></div>
        <div class="row-container">
          <p class="currency">R$</p>
          <h2 class="value-consulta">            
            <span>{{truncCurrency(monthlyValue)}}</span>
            <span class="decimal-currency">{{decimalCurrency(monthlyValue)}}</span>
          </h2>
          <p *ngIf="selectedToggle === 1 || classificationIdentifier === 'plano-mensal'" class="currency"> /mês</p>
        </div>      
        <p *ngIf=" periodicityValue !== 0 && (classificationIdentifier === 'plano-mensal' || selectedToggle === 1)" class="periodicity-installment" [ngStyle]="{'font-size': '13px'}">
          R$ {{ formatCurrency(productData.baseValue) }} parcelado em {{ periodicityValue }}x   
        </p>      
        <p *ngIf=" periodicityValue === 0 && (classificationIdentifier === 'plano-mensal' || selectedToggle === 1)" class="periodicity-installment" [ngStyle]="{'font-size': '13px'}">
          &nbsp;   
        </p>
        <p *ngIf="appliedDiscount && (classificationIdentifier === 'plano-mensal' || selectedToggle === 1) && productData !== currentProductData" class="highlight-discount">
          Desconto de <strong>{{ appliedDiscount }}</strong>
        </p> 
        <p *ngIf="(!appliedDiscount || productData === currentProductData) && productData.product.classificationIdentifier === 'plano-mensal'" class="disapear-highlight">
          &nbsp; 
        </p>
      </div>
      <div *ngIf="productData.extraBalanceValueSum" class="badge-bonus">
        <span>
          <b>+ R$ {{formatCurrency(productData.extraBalanceValueSum)}}</b>
          <br>
          <span class="nowrap"> de bônus</span>
        </span>
      </div>
      <div class="button-buy-container">
        <button [disabled]="productData === currentProductData"
          [ngClass]="{'disabled-btn': productData === currentProductData}" (click)="navigate($event)">
          {{ productData === currentProductData ? 'JÁ POSSUI' : 'COMPRAR' }}
        </button>
        <img class="drop-down" src="/assets/images/drop-down-icon.png"
          [ngClass]="{'up-arrow': showDropdown, 'down-arrow': !showDropdown}" (click)="toggleDropdown()">
      </div>
    </div>
    <div *ngIf="showDropdown" class="dropdown-menu 
    {{
  productData.preferred && productData !== currentProductData
  ? 'recomended-dropdown'
  : ''
  }} 
    {{
  productData === currentProductData ? 'actual-plan-dropdown' : ''
  }} 
    {{ showDropdown ? 'open' : '' }}">
      <div *ngFor="let feature of productData.featureList">
        <hr class="hr-dropdown {{
        productData.preferred && productData !== currentProductData
          ? 'recomended-hr'
          : ''
      }} {{
        productData === currentProductData ? 'actual-plan-hr' : ''
      }} ">
        <div class="feature-item-container">
          <p class="feature-item-name" [class.recomended-feature-item-name]="productData.preferred" class="feature-item-name {{
          productData.preferred && productData !== currentProductData
            ? 'recomended-feature-item-name'
            : ''
        }} {{
          productData === currentProductData ? 'actual-plan-feature-item-name' : ''
        }} ">{{ feature.name }}</p>
          <p class="feature-item-value" [class.recomended-feature-item-value]="productData.preferred" class="feature-item-value {{
          productData.preferred && productData !== currentProductData
            ? 'recomended-feature-item-value'
            : ''
        }} {{
          productData === currentProductData ? 'actual-plan-feature-item-value' : ''
        }} ">
            {{ feature.toValue ? feature.toValue : feature.fromValue }}/un
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Fim dos produtos de consulta -->
</div>

  <!-- RECARGA GARANTIDA -->

  <div *ngIf="classificationIdentifier === 'consulta-e-recuperacao-de-dividas' && type === 'recharge'"
  class="product-container-consulta {{ showDropdown ? 'no-bottom-borders' : '' }}">

  <div class="section-container ">
    <div class="section-consulta">
      <div class="consulta-container">
        <div class="row-container">
          <p class="currency">R$</p>
          <h2 class="value-consulta"><span>{{truncCurrency(productData?.baseValue)}}</span><span class="decimal-currency">{{decimalCurrency(productData?.baseValue)}}</span></h2>
         </div>
      </div>
      <div>
        teste 3
      </div>
      <div class="button-buy-container">
        <button (click)="onBuy()">
          COMPRAR
        </button>
        <img class="drop-down" src="/assets/images/drop-down-icon.png"
          [ngClass]="{'up-arrow': showDropdown, 'down-arrow': !showDropdown}" (click)="toggleDropdown()">
      </div>
    </div>
    <div *ngIf="showDropdown" class="dropdown-menu {{ showDropdown ? 'open' : '' }}">
      <div *ngFor="let feature of productData.featureList">
        <hr class="hr-dropdown">
        <div class="feature-item-container">
          <p class="feature-item-name" class="feature-item-name ">{{ feature.name }}</p>
          <p class="feature-item-value" class="feature-item-value">
            {{ feature.toValue ? feature.toValue : feature.fromValue }}/un
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- FIM PRODUTO RECARGA GARANTIDA -->